import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { ColorMode, LUXProvider, LUXV2Theme } from '@lux/core';
import { TranslateProvider, TranslateScope } from '@pegasus/translation';
import { CommercialMessagesProvider } from '@pegasus/commercial-messages';
import { ErrorBoundary } from '@browsing/components';
import { ConfigProvider, configShape } from '@browsing/config';

import LoadableGenericErrorMessage from '@client/components/shared/genericErrorMessage';

import '@client/styles/core.scss';

/* eslint-disable react/prop-types */
export default function AppRoot({ store, routes, translations, config }) {
    // for privacy page webview in app
    const { webviewOs, webviewTheme } = store.getState()?.clientDevice || {};
    return (
        <ConfigProvider config={config}>
            <TranslateProvider translations={translations}>
                <TranslateScope>
                    <Provider store={store}>
                        <LUXProvider
                            initialColorMode={
                                webviewOs && webviewOs !== '' && webviewTheme === 'dark'
                                    ? ColorMode.DARK
                                    : ColorMode.LIGHT
                            }
                            LUXTheme={LUXV2Theme}
                        >
                            <ErrorBoundary
                                fallbackUI={LoadableGenericErrorMessage}
                                componentName="AppRoot"
                            >
                                <CommercialMessagesProvider localeCode={config.localeCode}>
                                    <Router>{routes}</Router>
                                </CommercialMessagesProvider>
                            </ErrorBoundary>
                        </LUXProvider>
                    </Provider>
                </TranslateScope>
            </TranslateProvider>
        </ConfigProvider>
    );
}

AppRoot.propTypes = {
    store: PropTypes.object.isRequired,
    routes: PropTypes.object.isRequired,
    translations: PropTypes.object.isRequired,
    config: configShape.isRequired,
};
